import React from 'react';

const HiddenBoxesContext = React.createContext([]);

export default HiddenBoxesContext;
